export enum StorageKeys {
  user = "user",
  token = "token",
  isFirebaseLogin = "isFirebaseLogin",
  sideMenuvalue = "sideMenuValue",
  rememberMe = "rememberMe",
  deviceId = "deviceId",
  sharingObject = "sharingObject",
  systemConfiguration = "systemConfiguration",
  deletedPosts = "deleted-posts",
  fcmToken = "fcmToken",
  sessionId = "sessionId",
  dummySingup = 'dummySingup',
  deletedChatId = "deleted-chats",
  pendingFCMRegistrations = "pendingFCMRegistrations",
  offlineAppNotifications = "offlineAppNotifications",
}

export enum SocketEvents {
  Transport = 'websocket',
  connect = "connect",
  disconnect = "disconnect",
  reconnect = "reconnect",
  reconnect_attempt = "reconnect_attempt",
  reconnect_error = "reconnect_error",
  reconnect_failed = "reconnect_failed",
  connect_error = "connect_error",
  'error' = "error",
  priceupdate = "priceupdate",
  getstocksdata = "getstocksdata",
  ping = "ping",
  portfolioSummaryUpdate = "portfolio-summary-update",

  portfolioHoldingsUpdate = "portfolio-holdings-update",
  portfolioHoldingsUpdateunSubscribe = "portfolio-holdings-update-unsubscribe",
  portfolioSummaryUpdateUnSubscribe = "portfolio-summary-update-unsubscribe",
  searchStockByKeyword = "searchStockByKeyword",
  searchStockByKeywordAndMarket = "searchStockByKeywordAndMarket",
  getPredictionsByID = "getPredictionsByID",
  users = "users",
  portfolioCardUpdate = "portfolio-card-update",
  portfolioOverviewUpdate = "portfolio-overview-update",

  MARK_NOTIFICATION_READ = "MARK_NOTIFICATION_READ",
  NEW_NOTIFICATION = "newNotification",
  NOTIFICATION_READ = "NOTIFICATION_READ",
  NOTIFICATION_COUNT_UPDATE = "NOTIFICATION_COUNT_UPDATE",
  CONNECT_ERROR = "CONNECT_ERROR",
  ERROR = "ERROR",
  PONG = "PONG",
  
  // Trade Metrics Socket Events
  tradeMetricsUpdate = "trade-metrics-update",
  orderUpdate = "order-update",
  positionUpdate = "position-update",
  accountBalanceUpdate = "account-balance-update",
  tradeExecution = "trade-execution",
  orderHistory = "order-history",
  subscribeTradeMetrics = "subscribe-trade-metrics",
  unsubscribeTradeMetrics = "unsubscribe-trade-metrics",
  subscribeOrders = "subscribe-orders",
  unsubscribeOrders = "unsubscribe-orders",
  subscribePositions = "subscribe-positions",
  unsubscribePositions = "unsubscribe-positions",
  getOrderHistory = "get-order-history",
  getTradeExecutions = "get-trade-executions",
  
  // Portfolio Summary Events (Trade Metrics Socket)
  portfolioSummaryUpdateSubscribe = "portfolio-summary-update",
  portfolioSummaryUpdateUnsubscribe = "portfolio-summary-update-unsubscribe",
  portfolioSummaryUpdateListener = "portfolio-summary-update",
  
  // Portfolio Holdings Events (Trade Metrics Socket)
  portfolioHoldingsUpdateSubscribe = "portfolio-holdings-update",
  portfolioHoldingsUpdateUnsubscribe = "portfolio-holdings-update-unsubscribe",
  portfolioHoldingsUpdateListener = "portfolio-holdings-update",
  
  // Portfolio Overview Events (Trade Metrics Socket)
  portfolioOverviewUpdateSubscribe = "portfolio-overview-update",
  portfolioOverviewUpdateUnsubscribe = "portfolio-overview-update-unsubscribe",
  portfolioOverviewUpdateListener = "portfolio-overview-update",
  
  // Portfolio Card Events (Trade Metrics Socket)
  portfolioCardUpdateSubscribe = "portfolio-card-update",
  portfolioCardUpdateUnsubscribe = "portfolio-card-update-unsubscribe",
  portfolioCardUpdateListener = "portfolio-card-update",
  
  // Portfolio Trade Events (Trade Metrics Socket)
  portfolioTradeUpdateListener = "portfolio-trade-update",
}

export enum Reactions {
  like = "likeicon01.png",
  love = "likeicon02.png",
  blessed = "likeicon03.png",
  smooch = "likeicon04.png",
}

export enum ValidSortFilter {
  followersCount = "followersCount",
  followingCount = "followingCount",
  viewsCount = "viewsCount",
  diversification = "diversification",
  loss = "loss",
  gain = "gain",
  investments = "investments",
  trades = "trades",
  topGain = "topGainPrice",
  topLoss = "topLoss",
  avgGain = "avgGainPrice",
  avgLoss = "avgLoss",
  outreach = "outreach",
}
export enum ValidSortFilterTrades {
  name = "fullName",
  portfolio = "portfolio",
  symbols = "topSymbols",
  gains = "gains",
  trades = "trades",
}
export enum ValidSortFilterPrediction {
  name = "fullName",
  symbols = "topSymbols",
  prediction = "predictions",
  streak = "streak",
  accuracy = "avgAccuracy",
  score = "totalScore",
}


export enum ShareType {
  email = "email",
  message = "message",
  messenger = "messenger",
  facebook = "facebook",
  twitter = "twitter",
  x = "x",
  linkedin = "linkedin",
  instagram = "instagram",
  whatsapp = "whatsapp",
  slack = "slack",
  discord = "discord",
  telegram = "telegram",
  reddit = "reddit",
  copy = "copy",
  copyImg = "copyImg",
  copyUrl = "copyUrl",
}

export enum TrackingModules {
  // Notifications
  NOTIFICATIONS = "Notifications:",

  // Trades
  TRADES = "Trades:",

  // Stocks
  STOCKS = "Stocks:",

  // Stocks
  SOCKETS = "Socket:",

  // Filters
  FILTERS = "Filters:",

  // Media
  MEDIA = "Media:",

  // Symbols
  SYMBOLS = "Symbols:",

  // Posts
  POSTS = "Posts:",

  // Prices
  PRICES = "Prices:",

  // Prices
  PREDICTION = "Predictions:"

}
export enum TrackingEvents {


  newPostsLoaded = TrackingModules.POSTS + "New Posts Loaded",
  noPostsFound = TrackingModules.POSTS + "No Posts Found",
  loadingPosts = TrackingModules.POSTS + "Loading Posts",
  postsLoaded = TrackingModules.POSTS + "Posts Loaded",
  loadPostsError = TrackingModules.POSTS + "Load Posts Error",
  postedSuccessfully = TrackingModules.POSTS + "Posted Successfully",
  postFailed = TrackingModules.POSTS + "Post Failed",
  postAttempt = TrackingModules.POSTS + "Post Attempt",
  postFetchAttempt = TrackingModules.POSTS + "Post Fetch Attempt",
  postValidationFailed = TrackingModules.POSTS + "Post Validation Failed",
  postEdited = TrackingModules.POSTS + "Post Edited",
  postDeleted = TrackingModules.POSTS + "Post Deleted",
  postDeletedSuccessfully = TrackingModules.POSTS + "Post Deleted Successfully",
  postDeletedRequestSuccessfully = TrackingModules.POSTS + "Post Deleted Request Successfull",
  postDeleteFailed = TrackingModules.POSTS + "Post Delete Failed",
  postSharedSuccessfully = TrackingModules.POSTS + "Shared Successfully",
  postUpdationError = TrackingModules.POSTS + "Post Updation Error",
  postsFetching = TrackingModules.POSTS + "Fetch Posts",
  postMissingFeedId = TrackingModules.POSTS + "Feed ID is Missing.",
  postFetchedSuccess = TrackingModules.POSTS + "Results Fetched Successfully",
  postEmptyResult = TrackingModules.POSTS + "No Results Found",
  postFetchError = TrackingModules.POSTS + "Error Fetching Posts",
  postUpdatedSuccess = TrackingModules.POSTS + "Post Updated Successfully",





  // Notifications Events
  markNotificationAsRead = TrackingModules.NOTIFICATIONS + "Marking notification as read",
  markNotificationRead = TrackingModules.NOTIFICATIONS + "Marking notification as read",
  loadingNotifications = TrackingModules.NOTIFICATIONS + "Loading Notifications",
  loadedNotifications = TrackingModules.NOTIFICATIONS + "Notifications Loaded",
  loadNotifications = TrackingModules.NOTIFICATIONS + "Load Notifications",
  listeningForNotifications = TrackingModules.NOTIFICATIONS + "Listening For Notifications",
  notificationReceived = TrackingModules.NOTIFICATIONS + "Notification received",

  // Trade Related Events
  postTrade = TrackingModules.TRADES + "Posting Trade",
  postTradeValidationFailed = TrackingModules.TRADES + "Trade Post Validation Failed",
  tradePostAttempt = TrackingModules.TRADES + "Trade Post Attempt",
  tradeLimitPriceSet = TrackingModules.TRADES + "Trade Limit Price Set",
  tradeStopLossSet = TrackingModules.TRADES + "Trade Stop Loss Set",
  tradeTakeProfitSet = TrackingModules.TRADES + "Trade Take Profit Set",
  tradePostedSuccessfully = TrackingModules.TRADES + "Trade Posted Successfully",
  tradePostFailed = TrackingModules.TRADES + "Trade Post Failed",
  tradeReadyForConfirmation = TrackingModules.TRADES + "Trade Ready For Confirmation",
  tradeConfirmed = TrackingModules.TRADES + "Trade Confirmed",
  postingTradeError = TrackingModules.TRADES + "Trade Posting Error",
  tradeModalOpened = TrackingModules.TRADES + "Trade Modal Opened",
  tradeSymbolSelected = TrackingModules.TRADES + "Trade Symbol Selected",
  tradePortfolioSelected = TrackingModules.TRADES + "Trade Portfolio Selected",
  tradeTypeSelected = TrackingModules.TRADES + "Trade Type Selected",
  tradeUnitsChanged = TrackingModules.TRADES + "Trade Units Changed",
  tradePriceChanged = TrackingModules.TRADES + "Trade Price Changed",
  tradeValidationFailed = TrackingModules.TRADES + "Trade Validation Failed",
  tradeSubmissionStarted = TrackingModules.TRADES + "Trade Submission Started",
  tradeSubmissionSuccess = TrackingModules.TRADES + "Trade Submission Success",
  tradeSubmissionError = TrackingModules.TRADES + "Trade Submission Error",
  tradeStopLossChanged = TrackingModules.TRADES + "Trade Stop Loss Changed",
  tradeTakeProfitChanged = TrackingModules.TRADES + "Trade Take Profit Changed",

  // Stock Socket Events
  socketConnectionInitiated = TrackingModules.SOCKETS + "Socket Connection Initiated",
  socketConnected = TrackingModules.SOCKETS + "Socket Connected",
  socketDisconnected = TrackingModules.SOCKETS + "Socket Disconnected",
  socketManualDisconnect = TrackingModules.SOCKETS + "Socket Manual Disconnect",
  socketConnectionError = TrackingModules.SOCKETS + "Socket Connection Error",
  socketError = TrackingModules.SOCKETS + "Socket Error",
  socketReconnectAttempt = TrackingModules.SOCKETS + "Socket Reconnect Attempt",
  socketReconnectFailed = TrackingModules.SOCKETS + "Socket Reconnect Failed",
  socketReconnected = TrackingModules.SOCKETS + "Socket Reconnected",
  socketMaxReconnectAttempts = TrackingModules.SOCKETS + "Socket Max Reconnection Attempts",

  // Stock Data Events
  stockDataRequest = TrackingModules.STOCKS + "Stock Data Request",
  stockDataCountRequest = TrackingModules.STOCKS + "Stock Data Count Request",
  stockDataReceived = TrackingModules.STOCKS + "Stock Data Received",
  stockDataReceivedViaId = TrackingModules.STOCKS + "Stock Data Received Against Stock ID",
  stockDataError = TrackingModules.STOCKS + "Stock Data Error",
  stockFetchAllData = TrackingModules.SYMBOLS + "Stock All Stocks Symbols Data",
  stockGetAllStocksFilterCount = TrackingModules.STOCKS + "Stock All Stocks Filter Counts",
  stockFetchAllDataViaFilters = TrackingModules.STOCKS + "Stock All Stocks Symbols Data Via Filters",
  stockUpdateProcessingError = TrackingModules.STOCKS + "Stock Update Processing Error",
  stockUpdateProcessing = TrackingModules.STOCKS + "Stock Update Processing ",
  stockIdAdded = TrackingModules.STOCKS + "Stock ID Added",
  stockIdError = TrackingModules.STOCKS + "Stock ID Error",
  stockExistenceChecked = TrackingModules.STOCKS + "Stock Existence Checked",
  // Search Events
  stockSearchRequest = TrackingModules.STOCKS + "Stock Search Request",
  stockSearchResultsReceived = TrackingModules.STOCKS + "Stock Search Results Received",
  stockSearchError = TrackingModules.STOCKS + "Stock Search Error",


  // String Manipulation Events
  stringConversionAttempt = TrackingModules.FILTERS + "String Conversion Attempt",
  fetchLowestValues = TrackingModules.FILTERS + "fetchLowestValues",
  calculateDecimalPlaces = TrackingModules.FILTERS + "calculateDecimalPlaces",
  titleCaseConversion = TrackingModules.FILTERS + "Title Case Conversion",
  upperCaseConversion = TrackingModules.FILTERS + "UpperCase Conversion",
  spaceInsertionProcessing = TrackingModules.FILTERS + "Space Insertion Processing",
  textTruncationProcessing = TrackingModules.FILTERS + "Text Truncation Processing",
  systemNumberConvention = TrackingModules.FILTERS + "System Number Convention",
  systemAccuracyPercentage = TrackingModules.FILTERS + "System Accuracy Percentage",
  convertToTitleCase = TrackingModules.FILTERS + "convertToTitleCase",
  convertToUpperCase = TrackingModules.FILTERS + "convertToUpperCase",
  formatToMonthDay = TrackingModules.FILTERS + "formatToMonthDay",
  convertToMMDDYY = TrackingModules.FILTERS + "convertToMMDDYY",
  formatDate = TrackingModules.FILTERS + "formatDate",
  formatDateTwo = TrackingModules.FILTERS + "formatDateTwo",
  parseNumberIfInString = TrackingModules.FILTERS + "parseNumberIfInString",
  validateNumberInput = TrackingModules.FILTERS + "validateNumberInput",
  validateStockSymbol = TrackingModules.FILTERS + "validateStockSymbol",
  getStatsValue = TrackingModules.FILTERS + "getStatsValue",
  getClassByProfit = TrackingModules.FILTERS + "getClassByProfit",
  calcFunc = TrackingModules.FILTERS + "calcFunc",
  getFormattedTrades = TrackingModules.FILTERS + "getFormattedTrades",
  formatNumber = TrackingModules.FILTERS + "formatNumber",

  // Validation Events
  numberValidationAttempt = TrackingModules.FILTERS + "Number Validation Attempt",
  stockSymbolValidation = TrackingModules.FILTERS + "Stock Symbol Validation",
  urlValidationAttempt = TrackingModules.FILTERS + "URL Validation Attempt",
  inputValidationError = TrackingModules.FILTERS + "Input Validation Error",

  // Calculation Events
  profitCalculationAttempt = TrackingModules.FILTERS + "Profit Calculation Attempt",
  gainPercentageCalculation = TrackingModules.FILTERS + "Gain Percentage Calculation",
  tradeCalculationProcessing = TrackingModules.FILTERS + "Trade Calculation Processing",
  statsValueCalculation = TrackingModules.FILTERS + "Stats Value Calculation",
  decimalPlaceCalculation = TrackingModules.FILTERS + "Decimal Place Calculation",

  // Image Processing Events
  imageLoadAttempt = TrackingModules.MEDIA + "Image Load Attempt",
  imageLoadSuccess = TrackingModules.MEDIA + "Image Load Success",
  imageLoadError = TrackingModules.MEDIA + "Image Load Error",
  imageFallbackTriggered = TrackingModules.MEDIA + "Image Fallback Triggered",
  imageRetryAttempt = TrackingModules.MEDIA + "Image Retry Attempt",
  stockLogoLoadError = TrackingModules.MEDIA + "Stock Logo Load Error",
  stockLogoLoadSuccess = TrackingModules.MEDIA + "Stock Logo Load Success",


  // Add these new symbol events
  symbolsFetchStarted = TrackingModules.SYMBOLS + "Symbols Fetch Started",
  symbolsFetchSuccess = TrackingModules.SYMBOLS + "Symbols Fetch Success From Nasdaq API",
  symbolsFetchReqSuccess = TrackingModules.SYMBOLS + "Symbols Fetch Request Success with 200",
  symbolsFetchError = TrackingModules.SYMBOLS + "Symbols Fetch Error In Nasdaq API",
  symbolsFilterApplied = TrackingModules.SYMBOLS + "Symbols Filter Applied",
  symbolsPagination = TrackingModules.SYMBOLS + "Symbols Pagination",
  symbolsDataEmpty = TrackingModules.SYMBOLS + "No Symbols Data Returned From Nasdaq API",

  // User Data Events
  userDataRequest = "User Data Request",
  userDataReceived = "User Data Received",
  userDataError = "User Data Error",
  userUpdateProcessingError = "User Update Processing Error",

  // Prediction Data Events
  predictionDataRequest = TrackingModules.SOCKETS + "Prediction Data Request",
  predictionDataReceived = TrackingModules.SOCKETS + "Prediction Data Received",
  predictionHandlePredictionUpdate = TrackingModules.SOCKETS + "Prediction Data Handling",
  predictionDataReceivedViaId = TrackingModules.SOCKETS + "Prediction Data Received via Prediction ID",
  predictionDataError = TrackingModules.SOCKETS + "Prediction Data Error",
  predictionUpdateProcessingError = TrackingModules.SOCKETS + "Prediction Update Processing Error",
  predictionPostRequest = TrackingModules.PREDICTION + "Prediction Post Request Success",
  predictionPostRequestError = TrackingModules.PREDICTION + "Prediction Post Request Error",

  predictionUpdatePostRequest = TrackingModules.PREDICTION + "Prediction Update  Request Success",
  predictionUpdatePostRequestError = TrackingModules.PREDICTION + "Prediction Update Request Error",

  // Portfolio Events
  portfolioHoldingsSubscribed = "Portfolio Holdings Subscribed",
  portfolioHoldingsUnsubscribed = "Portfolio Holdings Unsubscribed",
  portfolioHoldingsUpdateError = "Portfolio Holdings Update Error",
  portfolioSummarySubscribed = "Portfolio Summary Subscribed",
  portfolioSummaryUnsubscribed = "Portfolio Summary Unsubscribed",
  portfolioSummaryUpdateError = "Portfolio Summary Update Error",
  portfolioCardSubscribed = "Portfolio Card Subscribed",
  portfolioCardUnsubscribed = "Portfolio Card Unsubscribed",
  portfolioCardUpdateError = "Portfolio Card Update Error",
  portfolioOverviewSubscribed = "Portfolio Overview Subscribed",
  portfolioOverviewUnsubscribed = "Portfolio Overview Unsubscribed",
  portfolioOverviewUpdateError = "Portfolio Overview Update Error",



  // Price Update Events
  priceUpdateReceived = TrackingModules.PRICES + "Price Update Received",
  priceUpdateProcessingError = TrackingModules.PRICES + "Price Update Processing Error",


  // Subscription Responses
  holdingsSubscriptionResponse = "Holdings Subscription Response",
  holdingsUnsubscriptionResponse = "Holdings Unsubscription Response",
  portfolioSummarySubscriptionResponse = "Portfolio Summary Subscription Response",
  portfolioSummaryUnsubscriptionResponse = "Portfolio Summary Unsubscription Response",
  portfolioCardSubscriptionResponse = "Portfolio Card Subscription Response",
  portfolioCardUnsubscriptionResponse = "Portfolio Card Unsubscription Response",
  portfolioOverviewSubscriptionResponse = "Portfolio Overview Subscription Response",
  portfolioOverviewUnsubscriptionResponse = "Portfolio Overview Unsubscription Response",

  // Data Parsing Events
  portfolioSummaryDataParsingError = "Portfolio Summary Data Parsing Error",
  portfolioCardDataParsingError = "Portfolio Card Data Parsing Error",

  // Listener Events
  portfolioSummaryListenerSetupError = "Portfolio Summary Listener Setup Error",
  portfolioCardListenerSetupError = "Portfolio Card Listener Setup Error",
  getComputedVariable = "getComputedVariable",
  insertSpaceBeforeCapitalLetter = "insertSpaceBeforeCapitalLetter",
  validStockLogoUrl = "validStockLogoUrl",
  getChartStockData = "getChartStockData",
  reactionAdded = "reactionAdded",
  reactionSuccess = "reactionSuccess",
  reactionFailed = "reactionFailed",
  reactionRemoved = "reactionRemoved",
  reactionRemoveSuccess = "reactionRemoveSuccess",
  reactionRemoveFailed = "reactionRemoveFailed",
  pollVoteFailed = "pollVoteFailed",
  firestorePersistenceEnabled = "firestorePersistenceEnabled",
  firestorePersistenceError = "firestorePersistenceError",
  firestoreGetDocumentError = "firestoreGetDocumentError",
  firestoreGetDocumentsError = "firestoreGetDocumentsError",
  firestoreAddDocumentError = "firestoreAddDocumentError",
  firestoreSetDocumentError = "firestoreSetDocumentError",
  firestoreUpdateDocumentError = "firestoreUpdateDocumentError",
  firestoreDeleteDocumentError = "firestoreDeleteDocumentError",
  firestoreSubscriptionError = "firestoreSubscriptionError",
  firestoreBatchError = "firestoreBatchError",
  firestoreTransactionError = "firestoreTransactionError",
  firestoreCountError = "firestoreCountError",
  firestoreNetworkError = "firestoreNetworkError",
  newPostsRefreshStarted = "newPostsRefreshStarted",
  newPostsRefreshed = "newPostsRefreshed",
  newPostsRefreshError = "newPostsRefreshError",
  newPostsDetected = "newPostsDetected",
  userPostCreatedNotification = "userPostCreatedNotification",
  userPostsMerged = "userPostsMerged",

  // Trade Metrics Events
  tradeMetricsUpdateReceived = "Trade Metrics Update Received",
  orderUpdateReceived = "Order Update Received",
  positionUpdateReceived = "Position Update Received",
  accountBalanceUpdateReceived = "Account Balance Update Received",
  tradeExecutionReceived = "Trade Execution Received",
  orderHistoryReceived = "Order History Received",
  tradeMetricsSubscriptionSuccess = "Trade Metrics Subscription Success",
  tradeMetricsSubscriptionError = "Trade Metrics Subscription Error",
  tradeMetricsUnsubscriptionSuccess = "Trade Metrics Unsubscription Success",
  tradeMetricsUnsubscriptionError = "Trade Metrics Unsubscription Error",
  ordersSubscriptionSuccess = "Orders Subscription Success",
  ordersSubscriptionError = "Orders Subscription Error",
  ordersUnsubscriptionSuccess = "Orders Unsubscription Success",
  ordersUnsubscriptionError = "Orders Unsubscription Error",
  positionsSubscriptionSuccess = "Positions Subscription Success",
  positionsSubscriptionError = "Positions Subscription Error",
  positionsUnsubscriptionSuccess = "Positions Unsubscription Success",
  positionsUnsubscriptionError = "Positions Unsubscription Error",
  orderHistorySuccess = "Order History Success",
  orderHistoryError = "Order History Error",
  tradeExecutionsSuccess = "Trade Executions Success",
  tradeExecutionsError = "Trade Executions Error",
  
  // Portfolio Summary Events (Trade Metrics Socket)
  portfolioSummaryUpdateSubscriptionSuccess = "Portfolio Summary Update Subscription Success",
  portfolioSummaryUpdateSubscriptionError = "Portfolio Summary Update Subscription Error",
  portfolioSummaryUpdateUnsubscriptionSuccess = "Portfolio Summary Update Unsubscription Success",
  portfolioSummaryUpdateUnsubscriptionError = "Portfolio Summary Update Unsubscription Error",
  portfolioSummaryUpdateListenerReceived = "Portfolio Summary Update Listener Received",
  portfolioSummaryUpdateListenerError = "Portfolio Summary Update Listener Error",
  
  // Portfolio Holdings Events (Trade Metrics Socket)
  portfolioHoldingsUpdateSubscriptionSuccess = "Portfolio Holdings Update Subscription Success",
  portfolioHoldingsUpdateSubscriptionError = "Portfolio Holdings Update Subscription Error",
  portfolioHoldingsUpdateUnsubscriptionSuccess = "Portfolio Holdings Update Unsubscription Success",
  portfolioHoldingsUpdateUnsubscriptionError = "Portfolio Holdings Update Unsubscription Error",
  portfolioHoldingsUpdateListenerReceived = "Portfolio Holdings Update Listener Received",
  portfolioHoldingsUpdateListenerError = "Portfolio Holdings Update Listener Error",
  
  // Portfolio Overview Events (Trade Metrics Socket)
  portfolioOverviewUpdateSubscriptionSuccess = "Portfolio Overview Update Subscription Success",
  portfolioOverviewUpdateSubscriptionError = "Portfolio Overview Update Subscription Error",
  portfolioOverviewUpdateUnsubscriptionSuccess = "Portfolio Overview Update Unsubscription Success",
  portfolioOverviewUpdateUnsubscriptionError = "Portfolio Overview Update Unsubscription Error",
  portfolioOverviewUpdateListenerReceived = "Portfolio Overview Update Listener Received",
  portfolioOverviewUpdateListenerError = "Portfolio Overview Update Listener Error",
  
  // Portfolio Card Events (Trade Metrics Socket)
  portfolioCardUpdateSubscriptionSuccess = "Portfolio Card Update Subscription Success",
  portfolioCardUpdateSubscriptionError = "Portfolio Card Update Subscription Error",
  portfolioCardUpdateUnsubscriptionSuccess = "Portfolio Card Update Unsubscription Success",
  portfolioCardUpdateUnsubscriptionError = "Portfolio Card Update Unsubscription Error",
  portfolioCardUpdateListenerReceived = "Portfolio Card Update Listener Received",
  portfolioCardUpdateListenerError = "Portfolio Card Update Listener Error",
  
  // Portfolio Trade Events (Trade Metrics Socket)
  portfolioTradeUpdateListenerReceived = "Portfolio Trade Update Listener Received",
  portfolioTradeUpdateListenerError = "Portfolio Trade Update Listener Error",
}